export default {
  setBranches: (state, branches) => {
    state.branches = branches
  },
  setBanks: (state, banks) => {
    state.banks = banks
  },
  setTillAccount: (state, tillAccount) => {
    state.tillAccount = tillAccount
  },
  setVaultAccount: (state, vaultAccount) => {
    state.vaultAccount = vaultAccount
  },
  setCurrentFinancialDate: (state, financialDate) => {
    state.financialDate = financialDate
  },
  corporateInformation: (state, corporateDetails) => {
    state.corporateDetails = corporateDetails
  },
  setInstitutionData: (state, data) => {
    state.institutionData = data
  },
  resetOperationState(state) {
    Object.keys(state).forEach(key => { state[key] = null })
  },
}
